import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoreInformationComponent } from '@teem/store-module/store-information.component';


const routes: Routes = [
	{
		path: "",
		component: StoreInformationComponent
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreInformationRoutingModule { }
